<template>
    <div class="upload-image" v-if="isInit">
        <el-form ref="form" :model="field" :label-width="field.name ? '120px' : '0'">
            <el-form-item
                class="input-row"
                :label="field.desc"
                prop="def_val"
                :rules="fieldRules">
                <div v-if="field.name" slot="label" class="label-item common">
                    <p class="label-text">{{ field.desc }}</p>
                    <el-tooltip class="item" effect="light" placement="bottom-start">
                        <div slot="content">
                            - name: <strong>{{ field.name }}</strong><br/>
                        </div>
                        <i class="label-icon el-icon-info"></i>
                    </el-tooltip>
                </div>
                <el-input class="field-input" :value="field.def_val" @input="valChangeHandler" placeholder="上传图片成功后，链接会自动填充到此处">
                    <el-button slot="append" icon="el-icon-zoom-in" @click="previewImage(field)">预览</el-button>
                </el-input>
            </el-form-item>
        </el-form>
        <div class="upload-control-wrap" v-loading.body="loading">
            <uploadImage
                class="upload-input"
                ref="uploadImageEle"
                :multiple="false"
                @image-uploaded="uploadImageHandler"/>
        </div>
        <el-dialog title="预览" width="500px" :visible.sync="previewShow" :modal="false">
            <div class="uploadimg-preview-wrap">
                <p class="text">链接：{{ previewData.url }}</p>
                <img class="preview-dom" :src="previewData.url">
            </div>
        </el-dialog>
    </div>
</template>
<script>
import moment from 'moment';
import cropperUpload from '../cropperUpload';
import dragUpload from '../dragUpload';
import apiPath from '@/service/apiPath.js';
import { requestApi } from '@/service/requestApi.js';
import uploadImage from '@/components/uploadImage';
import Vue from 'vue';

export default {
    name: 'upload-image',
    props: ['field', 'autoInit'],
    data() {
        return {
            // resField: this.field,
            fieldRules: {
                required: this.field.require,
                message: `请上传图片`,
                trigger: 'blur'
            },
            loading: false,
            previewData: {},
            previewShow: false,
            isInit: this.autoInit
        }
    },
    components: {
        uploadImage
    },
    watch: {
    },
    methods: {
        initData() {
            this.isInit = true;
        },
        fieldBeReady() {
            // 确认组件是否就绪
            return this.$refs['form'];
        },
        getResField() {
            let isValidate = false;
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    isValidate = true;
                } else {
                    isValidate = false;
                }
            });
            if (!isValidate) {
                return;
            }
            return this.field;
        },
        uploadImageHandler({ imageUrl, thumbUrl }) {
            let value = Vue.filter('url-proto')(imageUrl);
            this.field.def_val = value;
            this.$emit('val-change', value);
        },
        valChangeHandler(val) {
            this.field.def_val = val;
            this.$emit('val-change', val);
        },
        previewImage(row = {}) {
            this.previewData = {
                url: row.def_val
            };
            this.previewShow = true;
        },
    },
    computed: {
    },
    mounted() {
    }
}
</script>
<style lang="less">
    @import (reference) '../../styles/public.less';
    .upload-image {
        .label-item();
        .upload-control-wrap {
            padding-left: 60px;
        }
        .upload-type-radio {
            padding: 10px 0;
            .el-radio {
                background-color: #fff;
            }
        }
    }
    .uploadimg-preview-wrap {
        max-height: 600px;
        overflow-y: auto;
        .preview-dom {
            width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/compEditForm/uploadImage.vue